import React, { ChangeEvent } from 'react';
import styled from 'styled-components';
import { colors } from 'styleguide';

import { useMultiNodes } from 'craft/hooks';
import { PropToEdit } from 'craft/types';

import ValueBox from '../ValueBox';

export const StyledInput = styled.input`
  flex: 3;
  outline: none;
  padding: 0.5em;
  border: 1px solid ${colors('neutral', 3)};
  border-width: 0px 0px 0px 1px;
`;

interface Props {
  nodeIds: string[];
  propToEdit: PropToEdit;
}

const TextField = ({ nodeIds, propToEdit }: Props) => {
  const {
    actions: { setProps },
  } = useMultiNodes(nodeIds);
  // const [errorMessage, setErrorMessage] = useState(null);

  const { schema, value: currentValue } = propToEdit;
  const value = currentValue || schema.fieldType.defaultValue || '';

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const fieldValue = e.target.value;
    // TODO add validation messages if isRequired

    setProps({ [schema.id]: fieldValue });
  };

  return (
    <ValueBox label={schema.name}>
      <StyledInput value={value} onChange={onChange} />
    </ValueBox>
  );
};

export default TextField;
